
import { Component, Vue } from 'vue-property-decorator'
import { NewsService } from '@/services/index'
import { parseTime } from '@/common/utils'
import Editor from '@/components/editor/index.vue'

@Component({
    name: 'NewEdit',
    components: {
        Editor
    }
})
export default class extends Vue {
    private newsId: number = 0
    private newsForm: any = {
        title: '',
        content: '',
        published_at: '',
        meta_datas: []
    }
    private mediaType: any = 'media'
    private loading: boolean = true 
    private isSubmitting: boolean = false

    private mounted() {
        this.newsId = parseInt(this.$route.params.id)
        this.mediaType = this.$route.query.mtype || 'media'
        this.getDetail()
        this.getPlatforms()
    }

    private async getDetail() {
        const result = await NewsService.getDetail({ id: this.newsId, media_type: this.mediaType })
        if (result.status === 200) {
            const news = {
                id: result.data.id,
                title: result.data.title,
                content: result.data.content,
                published_at: result.data.published_at
            }
            this.newsForm = Object.assign(this.newsForm, news)
        }
        this.loading = false 
    }

    // 获取各个平台数据
    private async getPlatforms() {
        const result = await NewsService.getPlatforms({ news_id: this.newsId, media_type: this.mediaType })
        if (result.status === 200) {
            this.newsForm.meta_datas = result.data
        }
    }

    private async updateNews() {
        const result = await NewsService.updateNews({ ...this.newsForm, media_type: this.mediaType })
        if (result.status === 200) {
            this.$message({ type: 'success', message: '文章更新成功' })
        } else {
            this.$message({ type: 'error', message: result.message })
        }
    }

    private onContentChange(content: string) {
        this.newsForm.content = content
    }

    private async onSubmit() {
        this.isSubmitting = true
        this.newsForm.meta_datas.map((meta: any) => {
            meta.comment_count = parseInt(meta.comment_count)
            meta.interact_count = parseInt(meta.interact_count)
            meta.like_count = parseInt(meta.like_count)
            meta.read_count = parseInt(meta.read_count)
            meta.share_count = parseInt(meta.share_count)
            return meta
        })
        this.newsForm.published_at = parseTime(this.newsForm.published_at)
        await this.updateNews()
        this.isSubmitting = false
    }
}
